/**
 * Generated from MainMenuLayout.fla
 */
export function MainMenuLayout(this: IMainMenuLayout) {
	const bg = this.bg;
	MainMenuLayout_bg.call(this.bg);
	bg.x = 512;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const grover = this.grover;
	MainMenuLayout_grover.call(this.grover);
	grover.x = 224.9;
	grover.y = 642.9;
	grover.width = 217.50;
	grover.height = 486.00;
	if (grover.onLayout) grover.onLayout();
	const elmoButton = this.elmoButton;
	MainMenuLayout_elmoButton.call(this.elmoButton);
	elmoButton.x = 528;
	elmoButton.y = 534;
	elmoButton.width = 252.00;
	elmoButton.height = 259.00;
	if (elmoButton.onLayout) elmoButton.onLayout();
	const abbyButton = this.abbyButton;
	MainMenuLayout_abbyButton.call(this.abbyButton);
	abbyButton.x = 838.75;
	abbyButton.y = 534.25;
	abbyButton.width = 251.50;
	abbyButton.height = 258.50;
	if (abbyButton.onLayout) abbyButton.onLayout();
	const oscarButton = this.oscarButton;
	MainMenuLayout_oscarButton.call(this.oscarButton);
	oscarButton.x = 674.25;
	oscarButton.y = 235.25;
	oscarButton.width = 252.50;
	oscarButton.height = 258.50;
	if (oscarButton.onLayout) oscarButton.onLayout();
	return this;
}
function MainMenuLayout_bg(this: IMainMenuLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("main-menu-bg.png", 0.500, 0.500);
	return this;
}
function MainMenuLayout_grover(this: IMainMenuLayout_grover) {
	if (this.setLayoutTexture) this.setLayoutTexture("grover.png", 0.531, 0.993);
	return this;
}
function MainMenuLayout_elmoButton(this: IMainMenuLayout_elmoButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("lightsout.png", 0.500, 0.500);
	return this;
}
function MainMenuLayout_abbyButton(this: IMainMenuLayout_abbyButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("platerparty.png", 0.500, 0.500);
	return this;
}
function MainMenuLayout_oscarButton(this: IMainMenuLayout_oscarButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("trashblast.png", 0.500, 0.500);
	return this;
}
interface IMainMenuLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IMainMenuLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IMainMenuLayoutSprite extends IMainMenuLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IMainMenuLayoutText extends IMainMenuLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IMainMenuLayoutPolygon extends Array<number> {
}
interface IMainMenuLayout {
	readonly bg: IMainMenuLayout_bg;
	readonly grover: IMainMenuLayout_grover;
	readonly elmoButton: IMainMenuLayout_elmoButton;
	readonly abbyButton: IMainMenuLayout_abbyButton;
	readonly oscarButton: IMainMenuLayout_oscarButton;
}
interface IMainMenuLayout_bg extends IMainMenuLayoutSprite {
}
interface IMainMenuLayout_grover extends IMainMenuLayoutSprite {
}
interface IMainMenuLayout_elmoButton extends IMainMenuLayoutSprite {
}
interface IMainMenuLayout_abbyButton extends IMainMenuLayoutSprite {
}
interface IMainMenuLayout_oscarButton extends IMainMenuLayoutSprite {
}
